import React, {Component} from 'react';
import {Toast} from 'antd-mobile';
import Statistics from '../../../../../components/Statistics';
import {connect} from "react-redux";
import {getbillofdriver} from "../../../../../service/datastatistics";

@connect(
    state => ({userInfo: state.userInfo}),
)
export default class Now extends Component {
    constructor(props) {
        super(props);
        this.state = {
            totalData: {},
            dataList: [],
            // description: '明细表只能下载24小时以前的统计',
        };
    }

    componentDidMount() {
        Toast.loading('正在加载', 0);
        let params = {
            token: this.props.userInfo.token,
            "data": {
                "billType":1,
                "operatorType":1,
            }
        };
        getbillofdriver(params).then((res) => {
            console.log(res)
            Toast.hide();
            if (res.data.code === '0000') {
              
                this.setState({
                    totalData: res.data.data,
                    
                });
            }
        }).catch(function (error) {
            console.log(error);
        });
    }

    render() {
        return (
            <Statistics {...this.state}/>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Home/Index/DataStatistics/Before/index.js